var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CreateNewTaskDocument",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DefaultView-for-Document",
    transform: "translate(-432.000000, -255.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-ENTRY",
    transform: "translate(375.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Section-background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 375,
    height: 1080
  }), /*#__PURE__*/React.createElement("g", {
    id: "English",
    transform: "translate(0.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.853703, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "File-upload",
    transform: "translate(36.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "App-Icon",
    fill: "#007AFF",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75258,18.9289334 L10.9025,19.7731334 C10.16561,20.5035134 8.96714,20.5041434 8.23067,19.7731334 C7.87661,19.4218034 7.68215,18.9551834 7.68215,18.4591634 C7.68215,17.9631434 7.87682,17.4963134 8.23046,17.1449834 L11.35946,14.0405534 C12.00794,13.3975334 13.22783,12.4506434 14.11697,13.3324334 C14.525,13.7377334 15.18398,13.7350034 15.58907,13.3271834 C15.99437,12.9193634 15.99185,12.2601734 15.58382,11.8552934 C14.07245,10.3554734 11.83868,10.6326734 9.89324,12.5629934 L6.76403,15.6676334 C6.01328,16.4129234 5.6,17.4041234 5.6,18.4591634 C5.6,19.5142034 6.01328,20.5051934 6.76424,21.2504834 C7.53683,22.0169834 8.55134,22.4000234 9.56627,22.4000234 C10.58141,22.4000234 11.59634,22.0169834 12.36935,21.2500634 L13.22006,20.4056534 C13.62788,20.0007734 13.63019,19.3417934 13.22489,18.9337634 C12.82022,18.5261534 12.16061,18.5238434 11.75258,18.9289334 Z M21.23534,6.8692634 C19.61204,5.2585634 17.34236,5.1712034 15.8396,6.6622034 L14.77994,7.7140934 C14.37191,8.1191834 14.36939,8.7779534 14.77469,9.1859834 C15.17999,9.5940134 15.83897,9.5963234 16.247,9.1912334 L17.30624,8.1399734 C18.08471,7.3669634 19.10405,7.6874234 19.76891,8.3470334 C20.12339,8.6983634 20.31806,9.1651934 20.31806,9.6612134 C20.31806,10.1574434 20.12318,10.6242734 19.76933,10.9756034 L16.43096,14.2873034 C14.90447,15.8018234 14.18837,15.0909734 13.88282,14.7877334 C13.47479,14.3826434 12.81602,14.3851634 12.41072,14.7929834 C12.00542,15.2008034 12.00794,15.8599934 12.41597,16.2648734 C13.11674,16.9603934 13.91663,17.3052134 14.75516,17.3052134 C15.78185,17.3052134 16.86629,16.7881934 17.89739,15.7644434 L21.23576,12.4527434 C21.9863,11.7074534 22.4,10.7160434 22.4,9.6610034 C22.4,8.6063834 21.9863,7.6149734 21.23534,6.8692634 Z",
    id: "Link",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.ad34c270dbbc0bc7153bbc2570978c57.svg";
export { ForwardRef as ReactComponent };